import { AxiosError, isAxiosError } from "axios";
import { isNil } from "ramda";

import API from "lib/api";

import { getApolloClient } from "../apolloClient";

export type Credentials = {
  username: string;
  password: string;
};

export const fetchAuthToken = async (
  credentials: Credentials
): Promise<{ details: string; logout_token: string } | AxiosError | undefined> => {
  try {
    const response = await API.post<{ details: string; logout_token: string }>(`/auth/`, credentials);
    return response.data;
  } catch (e) {
    if (isAxiosError(e)) {
      return e;
    }
  }
};

export const loginUser = async (credentials: Credentials): Promise<{ responseStatus: string }> => {
  const result = await fetchAuthToken(credentials);

  if (isAxiosError(result)) {
    return !isNil(result.response)
      ? { responseStatus: `${result.response.status}` }
      : { responseStatus: "CANT_CONNECT" };
  }

  if (!isNil(result)) {
    const logoutToken = result?.logout_token;
    if (isNil(logoutToken)) {
      localStorage.removeItem("logoutToken");
    } else {
      localStorage.setItem("logoutToken", logoutToken);
    }
  } else return { responseStatus: "ERROR" };

  return { responseStatus: "OK" };
};

export const logoutRedirect = (options?: { skipTarget?: boolean }): void => {
  if (!options?.skipTarget) {
    if (window.location.pathname !== "/login") window.location.assign(`/login?target=${window.location.href}`);
    return;
  }
  window.location.assign("/login");
};

export const logout = async (logoutToken?: Maybe<string>): Promise<void | AxiosError> => {
  try {
    await API.get<void, void>("/v1/status/");

    // eslint-disable-next-line camelcase
    await API.post<void, void>("/auth/logout/", !isNil(logoutToken) ? { logout_token: logoutToken } : null);
    localStorage.removeItem("logoutToken");
    await getApolloClient()?.clearStore();
  } catch (e) {
    if (isAxiosError(e)) {
      return e;
    }
  }
};
